import { Link } from 'react-router-dom';
import { useParallax } from '../../hooks/useParallax';

export default function Footer() {
  const bgOffset = useParallax(0.15);

  return (
    <footer className="bg-gray-900 text-white py-12 relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-gradient-to-b from-gray-800/30 via-transparent to-gray-950/50 pointer-events-none"
        style={{ transform: `translate3d(0, ${bgOffset}px, 0)`, willChange: 'transform' }}
      />
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">
              <Link to="/" className="hover:text-orange-500 transition-colors cursor-pointer">
                iBen Consulting
              </Link>
            </h3>
            <p className="text-gray-400 text-sm">
              Guiding You Towards Smart IT Solutions
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Pages</h4>
            <div className="space-y-2">
              <Link
                to="/services"
                className="block text-gray-400 text-sm hover:text-orange-500 transition-colors cursor-pointer"
              >
                Services
              </Link>
              <Link
                to="/overview"
                className="block text-gray-400 text-sm hover:text-orange-500 transition-colors cursor-pointer"
              >
                Overview
              </Link>
              <Link
                to="/contact"
                className="block text-gray-400 text-sm hover:text-orange-500 transition-colors cursor-pointer"
              >
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <p>
                <a href="mailto:info@iben.co" className="hover:text-orange-500 transition-colors cursor-pointer">
                  info@iben.co
                </a>
              </p>
              <p>(650) 670-4236</p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link
                to="/privacy-policy"
                className="block text-gray-400 text-sm hover:text-orange-500 transition-colors cursor-pointer"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">©2020 by iBen Consulting.</p>
        </div>
      </div>
    </footer>
  );
}
